import * as T from '../../../../../../components/Table';
import { SummaryItem } from './SummaryItem';

export function Summary({ list }) {
  return (
    <T.Table borderCollapse="collapse" variant="striped">
      <T.Thead>
        <T.Th>Produto</T.Th>
        <T.Th>Quantidade</T.Th>
        <T.Th>Preço base</T.Th>
        <T.Th>SUBTOTAL. PB.</T.Th>
        <T.Th>Preço venda</T.Th>
        <T.Th>SUBTOTAL VALOR</T.Th>
        <T.Th>DIFERENÇA</T.Th>
        <T.Th>DIFERENÇA - 20%</T.Th>
      </T.Thead>
      <T.Tbody>
        {list?.map((item, index) => (
          <SummaryItem key={index} item={item} />
        ))}
      </T.Tbody>
    </T.Table>
  );
}
